
export const CMS_PAGE = "CMS_PAGE"
export const FAQ_GET = "FAQ_GET"
export const FAQ_GET_APP = "FAQ_GET_APP"
